import { AUTH_ROUTES } from '@lib/constants/apis';

import { AUTH_PANEL_DECKS } from './constants/auth-panel-decks';
import type { AuthPanelDeck } from './types/auth-panel-deck';

const SIGN_UP_ROUTES: readonly string[] = [
  AUTH_ROUTES.SIGNUP,
  AUTH_ROUTES.VERIFY_EMAIL,
];

/**
 * Sign-up and email verification get the sign-up deck;
 * every other auth route gets sign-in.
 */
export function authPanelDeckFor(pathname: string | null): AuthPanelDeck {
  const isSignUp = SIGN_UP_ROUTES.some(
    route => pathname === route || pathname?.startsWith(`${route}/`)
  );
  return AUTH_PANEL_DECKS[isSignUp ? 'signUp' : 'signIn'];
}
